import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Hidden from '@mui/material/Hidden';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { useAuth } from '@omnigenbiodata/ui';
import { PageWrapper, DMSALogo } from '@omnigenbiodata/ui';

import { useStyles } from './component.styles';

import ANIMATIONS from '../../core/constants/animations.constants';

interface MainLayoutProps {
  children: ReactNode;
  title?: string;
  showLogout?: boolean;
}

function MainLayout({ children, title = '', showLogout }: MainLayoutProps) {
  const { classes } = useStyles();
  const { signOut } = useAuth();
  return (
    <PageWrapper>
      {showLogout && (
        <Box textAlign="right" mb={2}>
          <Button size="large" variant="outlined" style={{ justifyContent: 'end' }} onClick={signOut}>
            LOG OUT
          </Button>
        </Box>
      )}
      <div className={classes.header}>
        <Link to="/" className={classes.logo}>
          <Hidden xsDown>
            <DMSALogo size="md" />
          </Hidden>
          <Hidden smUp>
            <DMSALogo size="responsive" />
          </Hidden>
        </Link>
      </div>

      {title && (
        <Typography className={classes.MainName} variant="h2" component="h1" align="center">
          {title}
        </Typography>
      )}
      <Fade in timeout={ANIMATIONS.duration}>
        <div className={classes.content}>{children}</div>
      </Fade>
    </PageWrapper>
  );
}

export default MainLayout;
